<template>
    <div>
        <workspace-header providedSecondaryTitle="FAQ" :isTpg="isTpg">
        </workspace-header>

        <div class="workspace-content" :class="{isTpg:isTpg}">

            <div class="searchContainer">
                <div class="searchBar"
                     :class="{isTpg:isTpg}">
                <input type="search"
                       v-model="searchTerm"
                       class="searchInput"
                       placeholder="Search FAQ">
                </div>
                </div>
            <div>

            <div class="paddy-bottom"></div>

            </div>

            <div v-for="header in faqHeaders" :key="header">
                <div class="faq-header" v-if="headerItems(header).length > 0" :class="{isTpg:isTpg}">
                    {{header}}
                </div>
                <div v-for="aq in headerItems(header)" class="faq" :class="{isTpg:isTpg}" :key="aq.question">
                        <div class="faq-q" @click="toggleFaq(aq)">
                            <div class="q-text">
                                {{ aq.question }}
                            </div>
                             <div class="downArrow" :class="{ 'fa-minus-circle': aq.show  == true, isTpg:isTpg}">
                                 <font-awesome-icon v-if="aq.show  == true" icon="minus-circle"  aria-hidden="false" />
                                 <font-awesome-icon v-else icon="plus-circle"  aria-hidden="false" />
                            </div>
                       </div>

                        <div class="faq-a" :class="{ selected: aq.show == false, isTpg:isTpg }">
                            <div>
                                <p v-html="aq.answer"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>

<script>

export default {
  data() {
    return {
      filteredFAQ: '',
      faq: [],
      faqHeaders: '',
      videos: [],
      videoURL: null,
      videoTitle: null,
      searchTerm: '',
      anchor: '',
    };
  },
  mounted() {
    // If FAQ item is specified, open that item
    this.checkForAnchor();
  },
  methods: {
    checkForAnchor() {
      if (window.location.hash) {
        let url = window.location.hash;
        url = url.substr(1);
        if (url.split('#')) {
          const splitter = url.split('#');
          if (splitter[1]) {
            this.anchor = splitter[1];
          }
        }
      }

      // Get our FAQ
      this.getFaq();
    },
    headerItems(header) {
      const headerItems = [];
      for (let i = 0; i < this.filteredFAQ.length; i++) {
        if (header == this.filteredFAQ[i].header) {
          headerItems.push(this.filteredFAQ[i]);
        }
      }

      return headerItems;
    },
    getFaq() {
      const self = this;
      this.$http.get('/faq').then((response) => {
        const faq_response = response.data;

        for (let i = 0; i < faq_response.length; i++) {
          if (faq_response[i].is_video == 1) {
            self.videos.push(faq_response[i]);
          } else {
            const faqItem = faq_response[i];
            // Show this if anchor specified in URL

            if (self.anchor && faqItem.anchor == self.anchor) {
              faqItem.show = true;
            } else {
              faqItem.show = false;
            }

            // Only show TPG or GV
            if ((self.showTPGFAQ && faqItem.is_tpg == 1) || (!self.showTPGFAQ && !faqItem.is_tpg)) {
              self.faq.push(faqItem);
            }

            self.filteredFAQ = self.faq;
          }
        }

        // Make headers
        if (self.faq) {
          self.makeHeadersArray();
        }
      });
    },
    makeHeadersArray() {
      const headers = [];

      for (let i = 0; i < this.faq.length; i++) {
        headers.push(this.faq[i].header);
      }

      this.faqHeaders = Array.from(new Set(headers));
    },
    toggleFaq(item) {
      if (item.show) {
        item.show = false;
      } else {
        item.show = true;
      }
    },
    showVideo(item) {
      this.videoURL = item.url;
      this.videoTitle = item.question;
      this.$refs.modal.show();
    },
    searchFAQ() {
      const matchedObjects = [];
      for (let i = 0; i < this.faq.length; i++) {
        if (this.faq[i].question.toLowerCase().includes(this.searchTerm.toLowerCase()) || this.faq[i].answer.toLowerCase().includes(this.searchTerm.toLowerCase())) {
          matchedObjects.push(this.faq[i]);
        }
      }

      return matchedObjects;
    },
  },
  props: ['user-info', 'is-tpg'],
  computed: {
    showTPGFAQ() {
      if (this.isTpg) {
        return true;
      }
      return false;
    },
  },
  watch: {
    searchTerm() {
      // If search empty, show entire faq
      if (this.searchTerm.length < 1) {
        this.filteredFAQ = this.faq;
        return;
      }

      this.filteredFAQ = this.searchFAQ();
    },
  },
};
</script>

<style>
.faq {
    padding:5px;
    font-size:13px;
    border-bottom: 1px solid rgba(50,50,50,.6);
    font-family:"Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
}
.faq:last-child {
    border-bottom: 0px;
}
.faq.isTpg {
    border-bottom: 1px solid #efefef;
}

.faq-header {
    width:100%;
    clear:both;
    text-align: left;
    font-size: 18px;
    background: rgba(50,50,50,.6);
    border-top:1px solid rgba(50,50,50,.6);
    border-bottom:1px solid rgba(50,50,50,.6);
    padding:5px;
}
.faq-header.isTpg {
    background: #ccc;
    border-top:1px solid #bcbcbc;
    border-bottom:1px solid #bcbcbc;
}
.faq-q {
    font-size:15px;
    cursor: pointer;
/*    text-transform: uppercase;*/
/*    font-weight: bold;*/
    margin-bottom: 7px;
    margin-top:7px;

}
.q-text {
    width:93%;
    float:left;
    font-weight: bold;
}
.faq-a {
    padding-bottom:0px;
}
.faq-a a{
    color:yellow;
}
.faq-a.isTpg a{
    color:rgba(1,172, 129,1);
}
.faq-a {
    clear:left;
}
.videoLink {
    cursor: pointer;
    color:yellow;
}
.selected {
    display: none;
}
@media (min-width:600px) {
    .downArrow {
    }
}
.downArrow {
    font-size: 20px;
    opacity: .8;

}
.downArrow.isTpg {
    color:#bcbcbc;
}
.flip {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
}

</style>
